import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL || '';

const getAllFaves = async (id) => {
    try {
        const response = await axios.get(`${apiUrl}/api/media/getallfaves/?id=${id}`);
        return response.data;
    } catch (error) {
        // No logging here, just return an empty array if there's an error or no favorites
        return [];
    }
};

const postFave = async (id, mediaData) =>{
    const { mediaId, mediaType } = mediaData

    const data = {
        id: id,
        mediaId: mediaId,
        mediaType: mediaType
    }


    const response = await
        axios.post(`${apiUrl}/api/media/postfave`, data)
    return response.data
}

const faveService = { getAllFaves, postFave }

export default faveService;
